// extracted by mini-css-extract-plugin
module.exports = {"pannel":"AboutSelectPannel_pannel_lSVqT","half":"AboutSelectPannel_half_2OEZj","active":"AboutSelectPannel_active_eJFRG"};